export const environment = {
  production: false,
  apiUrl: 'https://api.tecnologiaasap.com.br',
  baseUrl: 'https://api.tecnologiaasap.com.br',
  eventPlatform: 'https://events.hmgasap.com.br'
};
